import React, { useEffect, useState } from 'react'

interface ToastProps {
  message: string
}

const Toast: React.FC<ToastProps> = ({ message }) => {
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false)
    }, 2000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <div
      className={`fixed top-[175px] left-1/2 transform -translate-x-1/2 transition-opacity duration-300 ${
        visible ? 'opacity-100' : 'opacity-0'
      }`}
      data-testid="toast-message"
    >
      <div className="bg-gray-700 text-white text-lg py-4 px-[26px] rounded-[18px] shadow-lg whitespace-nowrap">
        {message}
      </div>
    </div>
  )
}

export default Toast
